'use strict';

export let CarritoRouteComponent = {

    selector: 'carritoRoute',
    template: require('./carrito-route.html'),
    controller: class {

        tipoEnvio = ['RETIRA', 'MENSAJERO', 'COLECTIVO', 'EMPRESA DE TRANSPORTE', 'OTROS'];
        tipoEnvioSeleccionado = this.tipoEnvio[0];
        detalleEnvio = '';

        /*@ngInject*/
        constructor(CarritoService, $location, ToasterService) {
            Object.assign(this, {CarritoService, $location, ToasterService});

            this.mensaje = '';
            this.enviardoOrder = false;
        }

        getArticulosCarrito() {
            return this.CarritoService.getArticulosCarrito();
        }

        getMontoTotalCarrito() {
            return this.CarritoService.getMontoTotalCarrito();
        }

        actualizarArticuloCarrito() {
            return this.CarritoService.actualizarArticuloCarrito();
        }

        quitarArticuloCarrito(articulo) {
            this.CarritoService.quitarArticuloCarrito(articulo);
        }

        vaciarCarrito() {
            this.CarritoService.vaciarCarrito();
        }


        generarOrder() {
            if (this.CarritoService.getCantidadArticulos() > 0) {
                this.enviardoOrder = true;
                this.CarritoService.generarOrder({mensaje: this.mensaje, envio: {tipo: this.tipoEnvioSeleccionado, mensaje: this.detalleEnvio}})
                    .then(() => {
                        this.CarritoService.vaciarCarrito();
                        this.$location.path('/');
                        this.ToasterService.popUp('success','Nueva Orden', 'Se ha generado con éxito.');
                    })
                    .catch(err => {
                        this.enviardoOrder = true;
                        this.ToasterService.error();
                    });
            }
        }
    }
};



// WEBPACK FOOTER //
// ./client/app/carrito-route/carrito-route.component.js